import { Navigate } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { LogoutLink } from "../auth/LogoutLink";
import { selectUser } from "../reducers/userSlice";

export const PrivateRoute = ({ children }) => {
  const user = useSelector(selectUser);
  if (typeof user !== `undefined` && user !== null) {
    return children;
  } else {
    return <Navigate to={`/login`}></Navigate>;
  }
};
